import { ReactNode } from "react";
export interface PaymentPropertyData {
	id: number;
	mid: number;
	merchantcode: string;
	businessemail: number | string;
	tradingname: string;
	mcc: string;
	firstname?: string;
	lastname?: string;
	email: string;
	provider: string;
	password: string;
	secretKey: string;
	currency: string;
	createdAt: string;
}

export const ColumnPaymentPropertyModule = [
	{
		Header: "Trading name",
		accessor: "tradingname",
	},

	{
		Header: "Provider",
		accessor: "provider",
	},

	{
		Header: "MID",
		accessor: "mid",
	},
	// {
	// 	Header: "Business email",
	// 	accessor: "businessemail",
	// },

	{
		Header: "Currency",
		accessor: "currency",
	},

	{
		Header: "Created at",
		accessor: "createdAt",
	},
];
